import * as z from "zod";
import { UnifiedOnboardingProductIdSchema } from "./product-ids";

export const completeUnifiedOnboardingProduct = {
  name: "completeUnifiedOnboardingProduct" as const,
  input: z.object({
    productId: UnifiedOnboardingProductIdSchema,
    /** Step payloads by step id; shared steps already done may be omitted. */
    stepValues: z.record(z.string(), z.record(z.string(), z.unknown())),
  }),
  output: z.object({ success: z.boolean(), error: z.string().optional() }),
};
